import { CompanyMember, CompanyMemberApiListCompanyMembersByMemberIdRequest } from "@vitable/asclepius-api-client-ts"

import useAsclepius from "@common/composables/api/asclepius"
import { Ref, ref, watch } from "vue"

export const useListCompanyMembersByMemberId = () => {
  const { getCompanyMemberApi, call, callResult } = useAsclepius()

  const companyMembers: Ref<Array<CompanyMember>> = ref([])

  async function listCompanyMembersByMemberId(request: CompanyMemberApiListCompanyMembersByMemberIdRequest) {
    await call(() => getCompanyMemberApi().listCompanyMembersByMemberId(request))
  }

  watch(callResult, (newValue) => {
    if (newValue.isSuccess()) {
      const data = callResult.value.getData()
      companyMembers.value = data.company_members
    }
  })

  return {
    listCompanyMembersByMemberId,
    listCompanyMembersResult: callResult,
    companyMembers
  }
}
